<template>
  <div style="display: flex; flex-direction: column; gap: 1rem">
    <div class="containerItens">
      <div class="descriptionSection">
        <b-icon-box-seam />
        <span> Informações dos Itens</span>
      </div>

      <div
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          gap: 1rem;
          margin-top: 5px;
        "
      >
        <div style="width: 100%">
          <b-row class="itemsSale" style="align-items: normal">
            <div
              v-if="lineProduct.tipoProduto === 'normal'"
              class="containerInputItem"
              size="sm"
            >
              <div class="inputItem" size="sm">
                <div class="infinite">
                  <InputInfinit
                    label="Itens"
                    typeFilter="itens"
                    :isEdit="lineProduct.id"
                    :dataInput.sync="lineProduct.idProduto"
                    :onSearch="fillProductsComboBoxWithPaginate"
                    :openCreateModal="
                      () =>
                        handleModalCreateProduct(
                          'modalCreateProduct',
                          lineProduct.idProduto
                        )
                    "
                    :findAll="createdNewProducts"
                    :clearSelected="toggleClearSelect"
                    :searchFields="['nome', 'codRef']"
                    @selectItem="selectProductSetDefaultValue($event, true)"
                  />
                  <span v-if="lineProduct.estoque >= 0" class="alertStock"
                    >Estoque Atual : {{ lineProduct.estoque }}</span
                  >
                  <span
                    v-if="lineProduct.estoque < 0"
                    class="alertStockNegative"
                    >Estoque Atual : {{ lineProduct.estoque }}</span
                  >
                </div>
              </div>
            </div>

            <div class="inputItemQnt">
              <InputQuant
                label="Qtd."
                :labelFixed="true"
                ref="refQtd"
                type="text"
                :dataInput.sync="lineProduct.quantidade"
                @calculateTotal="handleCalculateTotal"
                isSelectAll
              />
            </div>

            <div class="inputItemVlUnit">
              <InputMoney
                label="Vl. Unit"
                labelFixed
                ref="refVlUnit"
                type="text"
                :dataInput.sync="lineProduct.valorUnitario"
                @calculateTotal="handleCalculateTotal"
                isSelectAll
              />
            </div>

            <div class="inputItemVlTot">
              <InputMoney
                label="Vl. Total"
                labelFixed
                ref="valorTotal"
                type="text"
                isDisabled
                :dataInput.sync="lineProduct.valorTotal"
                @calculateTotal="handleCalculateTotal"
              />
            </div>

            <div class="inputItemDesc">
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  position: relative;
                "
              >
                <InputMoney
                  v-if="!discountIsChecked"
                  label="Desc"
                  :labelFixed="true"
                  type="text"
                  :dataInput.sync="lineProduct.desconto"
                  ref="discountItem"
                  @calculateTotal="handleCalculateTotal"
                  isSelectAll
                />

                <InputPercentage
                  v-else
                  label="Desc"
                  :labelFixed="true"
                  type="text"
                  :dataInput.sync="lineProduct.desconto"
                  ref="discountItem"
                  @calculateTotal="handleCalculateTotal"
                  isSelectAll
                />
              </div>
            </div>

            <div class="itemToggleDesc" style="width: 52px; height: 30px">
              <label class="switch col-sm-2 col-md-2 col-lg-2 col-xl-2">
                <input
                  type="checkbox"
                  ref="typeDiscount"
                  @click="alterDiscountIsChecked"
                  :value="discountIsChecked"
                  :disabled="validatorDesc"
                />
                <div class="slider">
                  <span>R$</span>
                  <span>%</span>
                </div>
              </label>
            </div>
          </b-row>
          <div class="fiscalFields">
            <InputSearchSelect
              label="Lista de NCM"
              valueField="codigo_ncm"
              textField="nomeNcm"
              :items="listNcms"
              :dataSelect.sync="lineProduct.ncm"
              :openCreateModal="() => openModals('modalNcms')"
              ref="ncm"
            />

            <div
              :class="[
                'item-tax-ref-field',
                { 'item-tax-ref-field-ref': !lineProduct.usar_imposto_manual },
              ]"
            >
              <ItemManualTax
                :item="lineProduct"
                modal-id="simple-item-manual-tax"
              />

              <InputSearchSelect
                style="width: calc(100% - 30px)"
                label="REF Fiscal"
                valueField="ref"
                textField="descricao"
                :items="allRefsFiscais"
                :additionalFilters="refFiscalFilters"
                @openFilters="loadRefFiscalCategories"
                :dataSelect.sync="lineProduct.classe_imposto"
                :openCreateModal="handleOpenModalRef"
                @changed="assignItemTaxFromRef"
                ref="classe_imposto"
              />
            </div>

            <div class="inputItemObs">
              <Input
                label="Observação"
                :labelFixed="true"
                type="text"
                :dataInput.sync="lineProduct.dadosAdicionais"
                ref="dadosAdicionais"
              />
            </div>

            <div
              class="btnAddMoreItems"
              :style="productLoading && 'align-items: flex-end'"
            >
              <button
                v-if="!productLoading"
                style="width: 100px; margin-top: 0.5rem"
                class="btnsSale btnAddMoreItems"
                @click="handleAddMoreItens"
              >
                {{ lineProduct.id ? "Atualizar" : "Adicionar" }}
              </button>

              <div
                v-else
                style="
                  width: 30px;
                  height: 30px;
                  background-color: #006256;
                  border-radius: 50%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <b-spinner class="spinProduct" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="containerTableItens">
        <div class="contentTableItens">
          <table
            class="tableProducts"
            style="width: 100%"
            v-if="outsideTableProducts.length"
          >
            <thead>
              <tr>
                <th style="width: 200px">Nome</th>
                <th style="width: 60px">Qnt</th>
                <th style="width: 120px">Vl. Unit</th>
                <th style="width: 99px">Desc</th>
                <th style="width: 120px">Vl. Total</th>
                <th style="width: 40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="tableItem"
                v-for="(product, idx) in outsideTableProducts.filter(
                  (prod) => prod.typeProduct === 'simples'
                )"
                :key="product.id"
                @click="!isLoadingToDelete && editProductsOfSale(product)"
              >
                <td style="width: 200px">
                  <div style="display: flex; gap: 0.5rem; align-items: center">
                    <span class="contentNumberItem">{{ idx + 1 }}</span>

                    <div style="width: calc(100% - 20px)">
                      <p class="textEllipsis" style="margin: 0">
                        {{ product.nome }}
                      </p>

                      <p
                        class="textEllipsis"
                        style="margin: 0; font-size: 9px; color: gray"
                      >
                        <span v-b-tooltip.hover.top="product.dadosAdicionais">
                          {{ product.dadosAdicionais }}
                        </span>
                      </p>
                    </div>
                  </div>
                </td>
                <td style="width: 60px">{{ product.quantidade }}</td>
                <td style="width: 120px">
                  {{ maskCurrency(product.valorUnitario) }}
                </td>
                <td style="width: 100px">
                  {{
                    sale.tipoDesconto === "Porcentagem"
                      ? maskPercentage(product.desconto)
                      : maskCurrency(product.desconto)
                  }}
                </td>
                <td style="width: 115px">
                  <p class="textEllipsis" style="margin: 0">
                    {{ handleCalculateTotalInTable(product) }}
                  </p>
                </td>
                <td style="width: 40px; position: relative; padding: 0">
                  <span
                    :class="`contentRemoveItem ${
                      (lineProduct.id === product.id || isLoadingToDelete) &&
                      'blockRemove'
                    }`"
                    @click.stop="removeItens(product.id)"
                    v-b-tooltip.hover.top="'Excluir'"
                    ><b-icon-trash style="color: white" scale="1.5"
                  /></span>
                  <div class="contentCloneItem">
                    <span
                      v-b-tooltip.hover.top="'Clonar'"
                      @click.stop="handleDuplicate(product)"
                      style="
                        width: 25px;
                        height: 25px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <b-icon-back style="color: #a8a8a8" scale="1.5" />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-else class="contentNotItems">
            <p>Nenhum produto adicionado...</p>
          </div>
        </div>
      </section>

      <div class="containerTotalsItems">
        <div class="rowTotalsItems" style="max-width: 80px">
          <div class="boxTotalsItems" style="background-color: #3b82ff40">
            <b-icon-box-seam scale="1.3" style="color: blue" />
          </div>

          <div>
            <p class="valueTotalsItems">
              {{ totals.amountItems }}
            </p>
          </div>
        </div>

        <div class="rowTotalsItems">
          <div
            class="boxTotalsItems"
            style="background-color: rgb(15 191 77 / 22%); font-size: 1rem"
          >
            $
          </div>

          <div>
            <p style="margin: 0">Subtotal</p>
            <p class="valueTotalsItems">
              {{ maskCurrency(totals.subtotalItems) }}
            </p>
          </div>
        </div>

        <div class="rowTotalsItems">
          <div
            class="boxTotalsItems"
            style="background-color: oklch(0.93 0.08 75.11)"
          >
            <b-icon-patch-minus scale="1.5" style="color: rgb(255 0 0)" />
          </div>

          <div>
            <p style="margin: 0">Desconto</p>
            <p class="valueTotalsItems">
              {{ maskCurrency(totals.totalDiscountItems) }}
            </p>
          </div>
        </div>

        <div class="rowTotalsItems" style="box-shadow: 0 0 0 1.5px #12b8a4">
          <div
            class="boxTotalsItems"
            style="background-color: #12b8a4; font-size: 1rem; color: white"
          >
            $
          </div>

          <div>
            <p style="margin: 0; color: #12b8a4; font-weight: 600">Total</p>
            <p class="valueTotalsItems">
              {{ maskCurrency(totals.totalValueItems) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="containerItens">
      <div class="descriptionSection">
        <b-icon-card-text />
        <span> Informações Adicionais </span>
      </div>

      <div
        class="mt-2"
        style="display: flex; align-items: center; flex-wrap: wrap; gap: 1rem"
      >
        <div style="flex: 1; min-width: 250px">
          <div style="display: flex; gap: 3px; align-items: center">
            <p class="obsGeneral">Gerais</p>

            <p class="observacoes">
              (Insira aqui observações que serão importantes para você)
            </p>
          </div>

          <textarea
            class="inputTextArea"
            rows="3"
            max-rows="6"
            v-model="sale.dadosAdicionais"
          />
        </div>

        <div style="flex: 1; min-width: 250px">
          <div style="display: flex; gap: 3px; align-items: center">
            <p class="obsGeneral">Nota Fiscal</p>

            <p class="observacoes">
              (Insira aqui, observações que sairão na Nota Fiscal do cliente)
            </p>
          </div>

          <textarea
            class="inputTextArea"
            rows="3"
            max-rows="6"
            v-model="sale.observacoesNf"
          />
        </div>
      </div>
    </div>

    <ModalCreateProducts
      @getAllNewProduct="handleCreatedNewProduct"
      :idProductFromSearch="idProductFromSearch"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations } from "vuex";
import { prescriptionProductError } from "./prescriptionProductRules";

import ModalCreateProducts from "../Modals/ModalCreateProduct.vue";
import Input from "../UI/CustomInputs/Input.vue";
import InputMoney from "../UI/CustomInputs/InputMoney.vue";
import InputQuant from "../UI/CustomInputs/InputQuant.vue";
import InputPercentage from "../UI/CustomInputs/InputPercentage.vue";
import InputInfinit from "../UI/CustomInputs/InputInfinit.vue";
import InputSearchSelect from "../UI/CustomInputs/InputSearchSelect.vue";
import RefFiscalFilters from "../../mixins/RefFiscalFilters";
import ItemManualTax from "../ModalTaxInformation/ItemManualTax.vue";

import ServiceProducts from "../../services/serviceProducts";
import ServiceProductSale from "../../services/serviceProductSale";

import { removeReference } from "../../utils/removeReference";
import {
  applyItemTaxFromRef,
  createManualTax,
  ensureItemTax,
} from "../../utils/itemTax";
import { ValidadeProductOfSale } from "../../validators/productOfSale";

import {
  mascaraMoeda,
  maskCurrency,
  maskPercentage,
} from "../../utils/maskMoney";

export default {
  mixins: [RefFiscalFilters],
  props: {
    sale: {
      type: Object,
      default: () => ({
        id: "",
        idCliente: "",
        tipoDesconto: "Valor Monetário",
        observations: null,
        observacoesNf: null,
      }),
    },
    outsideTableProducts: {
      type: Array,
      default: () => [],
    },
    outsideDesc: {
      type: Boolean,
    },
    totals: {
      typeof: Object,
    },
    listNcms: {
      type: Array,
      default: () => [],
    },
    allRefsFiscais: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Input,
    InputMoney,
    InputQuant,
    InputPercentage,
    InputInfinit,
    InputSearchSelect,
    ModalCreateProducts,
    ItemManualTax,
  },
  data() {
    return {
      lineProduct: {
        id: "",
        idVenda: "",
        idFornecedor: "",
        idProduto: "",
        typeProduct: "simples",
        quantidade: 1,
        valorUnitario: 0,
        valorTotal: 0,
        desconto: 0,
        dadosAdicionais: "",
        tipoProduto: "normal",
        estoque: 0,
        tipoPreco: "P1",
        ncm: null,
        classe_imposto: null,
        imposto_manual: createManualTax(),
        usar_imposto_manual: false,
      },
      total: "0,00",
      totalOfItens: "R$ 0,00",
      totalOfDiscount: "R$ 0,00",
      totalValue: 0,
      createdNewCustomer: false,
      createdNewProducts: null,
      maskCurrency: maskCurrency,
      maskPercentage: maskPercentage,
      idProductFromSearch: "",
      productLoading: false,
      toggleClearSelect: false,
      productAfterSelectItem: null,
      isLoadingToDelete: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_DATA_SEARCH_FROM_SALE",
      "SET_SALE_ID",
      "TOGGLE_DISCOUNT",
    ]),
    async handleAddMoreItens() {
      const restriction = prescriptionProductError(this.dataConfig, this.outsideTableProducts, this.lineProduct);
      if (restriction) return this.$toast.open({ message: restriction, type: "info" });
      if (!this.sale.idCliente) {
        return this.$toast.open({
          message: "(Cliente) deve ser selecionado para prosseguir",
          type: "info",
        });
      } else if (!this.sale.id) {
        const result = await this.$parent.createPrescription(false, false);

        this.lineProduct.idVenda = result.id;
      }

      this.lineProduct.id
        ? await this.updateProductOfSale()
        : await this.saveProductOfSale();

      this.$emit("findTableProductsOfSale");

      this.handleCalculateTotalsValues();
    },

    async saveProductOfSale() {
      try {
        this.lineProduct.idVenda = this.sale.id;

        if (!this.validadeProductOfSale(this.lineProduct)) return;

        await ServiceProductSale.save(this.lineProduct);
        this.clearLineProduct();

        return this.$toast.open({
          message: "Produto adicionado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : error?.response?.data?.message ||
              "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      } finally {
        this.productLoading = false;
      }
    },

    async updateProductOfSale() {
      try {
        this.lineProduct.idVenda = this.sale.id;

        if (!this.validadeProductOfSale(this.lineProduct)) return;

        await ServiceProductSale.update(this.lineProduct.id, this.lineProduct);
        this.clearLineProduct();

        return this.$toast.open({
          message: "Produto atualizado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : error?.response?.data?.message ||
              "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      } finally {
        this.productLoading = false;
      }
    },

    async editProductsOfSale(prod) {
      try {
        const newProd = removeReference(prod);
        this.assignProduct(newProd);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao editar o produto",
          type: "info",
        });
      }
    },

    assignProduct(prod) {
      this.lineProduct = ensureItemTax(prod, this.allRefsFiscais);

      this.$refs.refQtd.valueInput = prod.quantidade;
      this.$refs.refVlUnit.valueInput = prod.valorUnitario;
      this.$refs.valorTotal.valueInput = prod.valorTotal;
      this.$refs.discountItem.valueInput = prod.desconto;
      this.$refs.dadosAdicionais.valueInput = prod.dadosAdicionais;
      this.$refs.ncm.valueItems = prod.ncm || null;
      this.$refs.classe_imposto.valueItems = prod.classe_imposto || null;

      this.handleCalculateTotal();
    },

    clearLineProduct() {
      this.lineProduct = {
        id: "",
        idVenda: "",
        idFornecedor: "",
        idProduto: "",
        quantidade: 1,
        valorUnitario: 0,
        valorTotal: 0,
        dadosAdicionais: "",
        desconto: this.lineProduct.desconto,
        idProdutoComposicao: "",
        tipoProduto: "normal",
        estoque: 0,
        tipoPreco: "P1",
        ncm: null,
        classe_imposto: null,
        imposto_manual: createManualTax(),
        usar_imposto_manual: false,
      };

      this.lineProduct.desconto = 0;
      this.$refs.discountItem.valueInput = 0;

      this.$refs.refQtd.valueInput = 1;
      this.$refs.refVlUnit.valueInput = 0;
      this.$refs.valorTotal.valueInput = 0;
      this.$refs.dadosAdicionais.valueInput = "";
      this.$refs.ncm.valueItems = null;
      this.$refs.classe_imposto.valueItems = null;
      this.toggleClearSelect = !this.toggleClearSelect;
      this.productAfterSelectItem = null;
    },

    assignTotalItensValues() {
      const valorTotal = this.outsideTableProducts.reduce(
        (oldValue, product) => oldValue + product.valorTotal,
        0
      );

      this.totalOfItens = parseFloat(valorTotal).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    assignTotalDiscount() {
      if (this.discountIsChecked) {
        this.totalOfDiscount = this.calculateTotalDiscount();
        return;
      }

      this.totalOfDiscount = this.calculateTotalDiscountWithMonetaryValue();
    },

    assignTotalValue() {
      const formattedTotal = mascaraMoeda(this.totalOfItens);
      const formattedTotalDiscount = mascaraMoeda(this.totalOfDiscount);

      const newTotal = formattedTotal - formattedTotalDiscount;

      this.totalValue = newTotal.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    calculateTotalDiscount() {
      const discounts = this.outsideTableProducts.map((prod) => {
        const desc = prod.desconto;
        const totalValue = prod.valorTotal;

        return +((totalValue * desc) / 100).toFixed(2);
      });

      const totalValueWithDiscount = discounts.reduce(
        (oldValue, desc) => oldValue + desc,
        0
      );

      return totalValueWithDiscount.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    calculateTotalDiscountWithMonetaryValue() {
      const monetaryDiscounts = this.outsideTableProducts.map((prod) => {
        if (prod.desconto) {
          const desc = prod.desconto;

          return desc;
        }

        return 0;
      });

      const totalMonetaryWithDiscount = monetaryDiscounts.reduce(
        (oldValue, desc) => oldValue + desc,
        0
      );

      return totalMonetaryWithDiscount.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    handleCalculateTotal() {
      const amount = Number(this.lineProduct.quantidade);
      const unitaryValue = this.lineProduct.valorUnitario;
      const totalValue = amount * unitaryValue;

      if (!this.$refs.valorTotal) return;

      this.lineProduct.valorTotal = totalValue;

      let discountValue = 0;

      if (this.sale.tipoDesconto === "Porcentagem") {
        const result = (
          this.lineProduct.valorTotal *
          (this.lineProduct.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result);
      } else {
        discountValue = this.lineProduct.desconto;
      }

      this.$refs.valorTotal.valueInput = totalValue - discountValue;
    },

    async removeItens(id) {
      try {
        this.isLoadingToDelete = true;
        await ServiceProductSale.delete(id);
        this.handleCalculateTotalsValues();

        this.$emit("findTableProductsOfSale");

        return this.$toast.open({
          message: "Produto removido",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.message}` ||
            "Ocorreu um erro ao remover o produto!",
          type: "info",
        });
      } finally {
        this.isLoadingToDelete = false;
      }
    },

    validadeProductOfSale(prod) {
      const isNotValid = ValidadeProductOfSale(prod);

      if (isNotValid && Object.keys(isNotValid).length) {
        this.$toast.open({
          message: isNotValid.message,
          type: "info",
        });

        return false;
      }

      return true;
    },

    async handleDuplicate(productOfSale) {
      try {
        const newProd = ensureItemTax(
          removeReference(productOfSale),
          this.allRefsFiscais
        );
        newProd.id = "";

        await ServiceProductSale.save(newProd);
        this.handleCalculateTotalsValues();

        this.$emit("findTableProductsOfSale");

        this.$toast.open({
          message: "Item Clonado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao clonar o item",
          type: "info",
        });
      }
    },

    handleCalculateTotalInTable(prod) {
      let newTotalValue = 0;

      if (this.sale.tipoDesconto === "Porcentagem") {
        const result = (prod.valorTotal * (prod.desconto / 100)).toFixed(2);

        newTotalValue = parseFloat(prod.valorTotal - result);
      } else {
        newTotalValue = prod.valorTotal - prod.desconto;
      }

      return maskCurrency(newTotalValue);
    },

    async getProductById(idProduct) {
      const data = await ServiceProducts.getProductById(idProduct);
      return data;
    },

    async updateProductValue() {
      this.lineProduct.valorUnitario = this.productAfterSelectItem.valorVenda;

      if (this.$refs.refVlUnit) {
        this.$refs.refVlUnit.valueInput =
          this.productAfterSelectItem.valorVenda;
      }

      this.handleCalculateTotal();
    },

    async selectProductSetDefaultValue(product) {
      this.productAfterSelectItem = product;

      if (product) {
        this.lineProduct.estoque = await ServiceProducts.findStock(product.id);
        this.lineProduct.ncm = product.ncm || null;
        this.lineProduct.classe_imposto = product.refFiscal || null;
        this.assignItemTaxFromRef(product.refFiscal || null);
        this.$refs.ncm.valueItems = product.ncm || null;
        this.$refs.classe_imposto.valueItems = product.refFiscal || null;

        if (!this.lineProduct.id) {
          this.lineProduct.valorUnitario = product.valorVenda;

          this.$refs.refVlUnit.valueInput = product.valorVenda;

          this.lineProduct.ncm = product.ncm || null;
          this.lineProduct.classe_imposto = product.refFiscal || null;
          this.$refs.ncm.valueItems = product.ncm || null;
          this.$refs.classe_imposto.valueItems = product.refFiscal || null;

          const amount = Number(this.lineProduct.quantidade);
          const unitaryValue = this.lineProduct.valorUnitario;
          const total = amount * unitaryValue;

          this.lineProduct.valorTotal = total;
          this.$refs.valorTotal.valueInput = total;

          this.updateProductValue("P1");

          this.handleCalculateTotal();
        }
      }
    },

    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },

    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleOpenModalRef() {
      this.$emit("openModalRef", this.lineProduct.classe_imposto);
    },

    assignItemTaxFromRef(ref = this.lineProduct.classe_imposto) {
      applyItemTaxFromRef(this.lineProduct, ref, this.allRefsFiscais);
    },

    async alterDiscountIsChecked() {
      this.handleCalculateTotalsValues();
      this.handleCalculateTotal();

      this.TOGGLE_DISCOUNT(!this.discountIsChecked);
      this.$emit("updateSale");
    },

    handleCreatedNewProduct() {
      this.createdNewProducts = !this.createdNewProducts;
    },

    handleCalculateTotalsValues() {
      this.assignTotalItensValues();
      this.assignTotalDiscount();
      this.assignTotalValue();

      this.$emit("calculateTotalValues");
    },

    handleAssingTypeDiscount() {
      this.$nextTick(() => {
        if (this.sale.tipoDesconto === "Porcentagem") {
          this.$refs.typeDiscount.checked = true;
        } else {
          this.$refs.typeDiscount.checked = false;
        }
      });
    },

    clearAll() {
      this.totalOfItens = "R$ 0,00";
      this.totalOfDiscount = "R$ 0,00";
      this.totalValue = "R$ 0,00";

      this.clearAllRefs();
    },

    clearAllRefs() {
      this.$refs.valorTotal.valueInput = 0;
      this.$refs.refVlUnit.valueInput = 0;
    },
  },
  mounted() {
    this.assignTotalItensValues();
    this.assignTotalDiscount();
    this.assignTotalValue();

    this.handleCalculateTotal();
    this.handleAssingTypeDiscount();
  },
  filters: {
    moment(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  },
  computed: {
    ...mapState({
      dataBudgetForSale: (state) => state.dataBudgetForSale,
      dataSearchFromSale: (state) => state.dataSearchFromSale,
      dataConfig: (state) => state.dataConfig,
      discountIsChecked: (state) => state.discountIsChecked,
    }),
    objectTotal() {
      return {
        totalItems: this.totalOfItens,
        totalDiscount: this.totalOfDiscount,
        total: this.totalValue,
      };
    },
    validatorDesc() {
      let existsDiscount = false;

      if (this.outsideTableProducts.length) {
        for (const product of this.outsideTableProducts) {
          if (product.desconto) {
            existsDiscount = true;
            break;
          }
        }
      }

      return existsDiscount;
    },
    existsNf() {
      if (this.dataSearchFromSale?.id && this.dataSearchFromSale?.nf?.id) {
        return this.dataSearchFromSale?.nf?.status === "Emitida" ||
          this.dataSearchFromSale?.nf?.status === "Cancelada"
          ? true
          : false;
      }

      return false;
    },
  },
  watch: {
    discountIsChecked() {
      this.$refs.typeDiscount.checked =
        this.sale.tipoDesconto === "Porcentagem" ? true : false;
    },
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_SALE({});
    this.SET_SALE_ID("");
  },
};
</script>

<style scoped>
.containerItens {
  border: 1px solid #c8dfd5;
  border-radius: 5px;
  padding: 10px;
}

.descriptionSection {
  gap: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.descriptionSection span {
  font-size: 0.8rem;
}

.containerInputItem {
  width: 40%;
  position: relative;
  min-width: 320px;
}

.inputItem {
  width: 100%;
  min-width: 320px;
  position: relative;
}

.inputItemObs {
  width: 100%;
  max-width: 300px;
  margin-top: 0.5rem;
}

.input:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}

.custom-select:hover {
  background: #d9d9d9;
  border: 1px solid #262626;
}

.inputItemQnt {
  width: 8%;
}

.inputItemVlUnit {
  width: 13%;
}

.inputItemVlTot {
  width: 13%;
}

.inputItemDesc {
  width: 10%;
}

.itemToggleDesc {
  width: 52px;
  position: relative;
}

.containerTableItens {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  flex-wrap: wrap-reverse;
}

.contentTableItens {
  width: 100%;
  height: 242px;
  border: dashed 1px #c1c1c1;
  border-radius: 5px;
  padding: 0.3rem 0.5rem;
}

.tableProducts {
  display: table;
  width: 100%;
  border-spacing: 0;
  margin-top: 0.5rem;
}

.tableProducts thead tr th {
  padding: 0 0.5rem;
  font-weight: normal;
}

.tableProducts thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.tableItem {
  height: 50px;
  background-color: whitesmoke;
  box-shadow: 0 1px 3px rgb(0 0 0 / 24%);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  position: relative;
  transition: ease 0.2s;
}

.tableItem:hover {
  background-color: rgb(218, 218, 218);
  transition: ease 0.2s;
}

.tableItem td {
  text-align: start !important;
  padding: 0 0.5rem;
}

.textEllipsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 60px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.obsGeneral {
  font-size: 12px;
  color: #666360;
  font-family: Poppins-Medium, sans-serif !important;
  font-weight: 500;
}

.observacoes {
  font-size: 11px;
  color: #a0a0a0;
  font-style: italic;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 500;
}

.spinProduct {
  color: white;
  width: 20px;
  height: 20px;
}

.contentNumberItem {
  height: 18px;
  width: 18px;
  min-width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: gray;
  color: white;
}

.contentRemoveItem {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 5px 5px 0;
  background-color: brown;
  box-shadow: -1px 0 2px rgb(0 0 0 / 24%);
}

.blockRemove {
  background-color: rgb(144, 85, 85);
  pointer-events: none !important;
  cursor: default !important;
}

.containerTotalsItems {
  display: flex;
  gap: 1rem;
  padding: 0.8rem;
  background-color: rgb(248 248 248);
  margin-top: 1rem;
  border-radius: 8px;
}

.rowTotalsItems {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex: 1 1 auto;
  max-width: 200px;
  background-color: white;
  padding: 0.3rem 0.5rem;
  border-radius: 8px;
  box-shadow: 0px 0 0px 1px rgba(0, 0, 0, 0.207);
}

.boxTotalsItems {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.valueTotalsItems {
  margin: 0;
  font-weight: 600;
  color: black;
  font-size: 13px;
}

.contentCloneItem {
  position: absolute;
  right: 30px;
  top: 0;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentNotItems {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentNotItems p {
  font-size: 16px;
  color: #c1c1c1;
}

.infinite {
  position: relative;
}

.codRef {
  margin-left: 1rem;
  width: 30%;
  position: relative;
  display: flex;
  flex-direction: column;
}

p {
  margin: 0;
}

.radio-input input {
  display: none;
}

.radio-input {
  position: absolute;
  right: 0;
  top: -2px;
  display: flex;
  --container_width: 130px;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  color: #000000;
  width: var(--container_width);
  overflow: hidden;
  border: 1px solid rgba(53, 52, 52, 0.226);
}

.radio-input label {
  width: 100%;
  padding: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 11px;
  margin-bottom: 0px !important;
}

.selection {
  display: none;
  position: absolute;
  height: 100%;
  width: calc(var(--container_width) / 3);
  z-index: 0;
  left: 0;
  top: 0;
  transition: 0.15s ease;
}

.radio-input label:has(input:checked) {
  color: #fff;
}

.radio-input label:has(input:checked) ~ .selection {
  background-color: #3a4750;
  display: inline-block;
}

.radio-input label:nth-child(1):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 0 / 3));
}

.radio-input label:nth-child(2):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 1 / 3));
}

.radio-input label:nth-child(3):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 2 / 3));
}

.btnReplaceAll {
  border-radius: 5px;
  background-color: #a8a8a8;
  border: none;
  color: white;
  font-size: 12px;
  width: 20px;
  height: 20px;
  padding: 0.2rem;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.btnReplaceAll:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.353);
  background-color: rgb(116, 116, 116);
  transition: ease-in all 0.1s;
}

.btnsSale {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  height: 30px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.btnAddMoreItems {
  display: flex;
  justify-content: center;
  align-items: center;
}

.isDisabled {
  background-color: #e1e1e1;
}

.alertStock {
  font-size: 10px;
  color: #3e66ae;
  position: absolute;
  top: -15px;
  right: 5px;
}

.alertStockNegative {
  font-size: 10px;
  color: #ff1d08;
  position: absolute;
  top: -18px;
  right: 5px;
}

.contentTitleItens {
  align-items: center !important;
}

/* The slider */
.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.itemsSale {
  position: relative;
  display: flex;
  gap: 15px;
  margin-left: 0;
}

.fiscalFields {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  width: 100%;
  margin-top: 0.6rem;
}

.item-tax-ref-field {
  position: relative;
  min-width: 0;
}

.item-tax-ref-field-ref {
  box-sizing: border-box;
  /* padding-right: 24px; */
}

.fiscalFields > div:not(.btnAddMoreItems) {
  flex: 1;
  max-width: 300px;
}

.fiscalFields .btnAddMoreItems {
  flex: 0 0 auto;
}

.title {
  font-size: 14px;
  color: #666360;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.tooltipDiscount {
  z-index: 3;
  width: 150px;
  padding: 5px;
  font-size: 12px;
  position: absolute;
  color: black;
  border-radius: 5px;
  top: -25px;
  right: -10px;
}

.tooltipItems {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 886px) {
  .contentTableItens {
    width: 100%;
  }
}

@media screen and (max-width: 1300px) {
  .inputItemObs {
    width: 270px;
  }

  .inputItemQnt {
    width: 80px;
  }

  .inputItemVlUnit {
    width: 100px;
  }

  .inputItemVlTot {
    width: 100px;
  }

  .inputItemDesc {
    width: 105px;
  }
}

@media screen and (min-width: 769px) {
  .tableProducts tbody {
    display: block;
    height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 0.5rem;
    padding: 5px !important;
  }
}

@media screen and (max-width: 800px) {
  .containerInputItem {
    width: 72%;
  }

  .inputItemObs {
    width: 60%;
  }

  .inputItemQnt {
    width: 25%;
  }

  .inputItemVlUnit {
    width: 28%;
    margin-top: 0.5rem;
  }

  .inputItemVlTot {
    width: 28%;
    margin-top: 0.5rem;
  }

  .inputItemDesc {
    width: 28%;
    margin-top: 0.5rem;
  }

  .itemToggleDesc {
    margin-top: 0.5rem;
  }
}

@media screen and (max-width: 768px) {
  .tooltipDiscount {
    right: -85px;
    top: -28px;
  }

  .tableProducts tbody {
    display: block;
    height: 200px;
    margin-top: 0.5rem;
    padding: 5px !important;
  }

  .contentTableItens {
    overflow-x: auto;
  }
}

@media screen and (max-width: 475px) {
  .containerInputItem,
  .inputItem {
    width: 100%;
    min-width: 100% !important;
  }

  .inputItemQnt {
    width: 31.6%;
    margin-top: 0.5rem;
  }

  .inputItemVlUnit {
    width: 31.6%;
    margin-top: 0.5rem;
  }

  .inputItemVlTot {
    width: 31.6%;
    margin-top: 0.5rem;
  }
}

@media screen and (max-width: 400px) {
  .itemsSale {
    margin: 0 !important;
  }

  .btnAddMoreItems {
    width: 100% !important;
  }

  .inputItem {
    width: 100%;
    min-width: 100% !important;
  }

  .inputItemObs {
    width: 100%;
  }

  .inputItemQnt {
    width: 25%;
    margin-top: 0.5rem;
  }

  .inputItemVlUnit {
    width: 33%;
    margin-top: 0.5rem;
  }

  .inputItemVlTot {
    width: 33%;
    margin-top: 0.5rem;
  }

  .inputItemDesc {
    width: 62%;
    margin-top: 0.5rem;
  }

  .itemToggleDesc {
    margin-top: 0.5rem;
  }
}

.fistTitle {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.custom-select:disabled {
  color: black;
  background-color: #d5d3d3;
}

.custom-select {
  background: none;
  text-transform: capitalize;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .contentTitleItens {
    padding: 0 !important;
  }

  .itemsSale {
    margin-left: 0px;
    margin-right: 0px;
  }

  .btnsSale {
    width: 140px;
    margin-top: 15px;
    font-size: 10px;
  }

  .col-12,
  .col-sm-12,
  .col-md-12,
  .col-lg-12,
  .col-xl-12 {
    padding-right: 0px;
    padding-left: 10px;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
    align-items: center;
    align-content: center;
    justify-content: flex-start;
  }

  .col-md-6 {
    flex: 0 0 32%;
    max-width: 32%;
  }

  .col-md-5 {
    flex: 0 0 32%;
    max-width: 32%;
  }
}

@media (min-width: 576px) and (max-width: 1200px) {
  .col-sm-6 {
    flex: 0 0 32%;
    max-width: 32%;
  }
}

@media screen and (max-width: 700px) {
  .containerTableItens {
    padding-left: 15px;
  }

  .contentTitleItens {
    margin-left: 0 !important;
    padding-left: 16px !important;
  }

  .tooltipDiscount {
    right: -15px;
    top: -23px;
  }

  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col,
  .col-auto,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm,
  .col-sm-auto,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md,
  .col-md-auto,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg,
  .col-lg-auto,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl,
  .col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 0px;
    padding-left: 15px;
  }

  .infinite {
    padding-right: 15px;
  }

  .row {
    gap: 10px;
  }

  .itemsSale {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px !important;
    padding-left: 16px;
    margin-right: 16px;
    width: 100%;
  }
}

@media screen and (max-width: 547px) {
  .tooltipDiscount {
    right: -85px;
    top: -30px;
  }

  .itemToggleDesc,
  .inputItemObs {
    margin-top: 1rem;
  }
}
</style>
